import FeatureSettingsService from "./featureSettingsService";
import NavigationService from "./navigation";
import DeviceComplianceSettingsProvider from "./deviceComplianceSettingsProvider";
import Cookies from 'universal-cookie';
import { SessionStorageKeys } from "./sessionStorageKeys.const";
export default class OnboardingRedirectionService {

    constructor() {
        this.cookies = new Cookies();
    }

    processOnboardingV3Redirection(defaultRedirection) {
        if (typeof defaultRedirection !== 'function') {
            throw new Error('"defaultRedirection" should be provided');
        }

        FeatureSettingsService.init().then(() => {
            const isOnboardingV3Enabled = sessionStorage.getItem(SessionStorageKeys.onboardingV3Enabled) === 'enabled';            
            if (!isOnboardingV3Enabled) {                
                defaultRedirection();                
                return false;
            }

            if (!FeatureSettingsService.isFeatureEnabled('onboardingWithInterruptionsEnabled')) {
                defaultRedirection(); 
                return false;
            }

            const onboardingStatus = sessionStorage.getItem(SessionStorageKeys.onboardingStatus);
            if (onboardingStatus === 'SignUp' || onboardingStatus === 'SmsVerified') {	
                NavigationService.goToWebappUrl('/signup/v2/progress?step=confirmName', 'onboarding');
            } else if (onboardingStatus === 'InProgress') {
                NavigationService.goToWebappUrl('/signup/v2/mobile-set-up', 'onboarding');
            } else if (onboardingStatus === 'DeviceSignIn') {								
                const deviceComplianceCheckInfo = DeviceComplianceSettingsProvider.getOnboardingV3Settings();
                this.cookies.set('w-device-compliance-check-info', JSON.stringify(deviceComplianceCheckInfo), { path: '/' });
                NavigationService.goToWebappUrl('/', 'device-check');								
            } else {
                defaultRedirection(); 
            }
        }); 
    }
}


// WEBPACK FOOTER //
// ./src/scripts/services/onboardingRedirectionService.js